module.exports = __webpack_public_path__ + "assets/img/goods-corporate.f79e4fca.png";